import axios from "axios";

export const state = {
    antental_save_status: false,
    religions: [],
    antenatal_visits: [],
    occupations: [],
    education_levels: [],
    tribes: [],
    spouses: [],
    anteboiodata: {},
};

export const getters = {
    Religions: state => state.religions.data,
    AntentalSaveStatus: state => state.antental_save_status,
    Occupations: state => state.occupations.data,
    EducationLevels: state => state.education_levels.data,
    Tribes: state => state.tribes.data,
    Spouses: state => state.spouses.data,
    AntePatientboiodata: state => state.anteboiodata.data,
    patient_Antenatal_visits: state => state.antenatal_visits.data,
};

export const mutations = {
    ANTENATAL_SAVE_STATUS: (state, newValue) => state.antental_save_status = newValue,
    SET_RELIGIONS: (state, newValue) => state.religions = newValue,
    SET_OCCUPATIONS: (state, newValue) => state.occupations = newValue,
    SET_EDUCATION_LEVELS: (state, newValue) => state.education_levels = newValue,
    SET_TRIBES: (state, newValue) => state.tribes = newValue,
    SET_SPOUSES: (state, newValue) => state.spouses = newValue,
    SET_ANTENATAL_PATIENT_BIODATA: (state, newValue) => state.anteboiodata = newValue,
    EMPTY_ANTE_BIODATA: (state) => state.anteboiodata = {},
    SET_PATIENT_ANTENATAL_VISITS: (state, newValue) => state.antenatal_visits = newValue,
};
export const actions = {
    fetchAntenatalBioData({ commit, dispatch }, patient_id) {
        commit('EMPTY_ANTE_BIODATA', true)
        commit('ANTENATAL_SAVE_STATUS', true)
        axios.get(`atenetal_details/${patient_id}`).then(sres => {
            commit('SET_ANTENATAL_PATIENT_BIODATA', sres.data)
            commit('ANTENATAL_SAVE_STATUS', sres.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchPateintAntenatalVisits({ commit }, patient_id) {
        commit('ANTENATAL_SAVE_STATUS', true)
        axios.get(`atenetal_visit/${patient_id}`).then(pares => {
            commit('SET_PATIENT_ANTENATAL_VISITS', pares.data)
            commit('ANTENATAL_SAVE_STATUS', false)
        })
    },
    SaveAntenatalBioData({ commit, dispatch }, payload) {
        commit('ANTENATAL_SAVE_STATUS', true)
        axios.post('atenetal_details', payload).then(() => {
            commit('ANTENATAL_SAVE_STATUS', false)

            setTimeout(() => {
                dispatch('fetchReligions')
                dispatch('fetchOccupations')
                dispatch('fetchEducationLevels')
                dispatch('fetchTribes')
                dispatch('fetchSpouse')
            }, 1000);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchReligions({ commit }) {
        axios.get('religions').then(rres => {
            commit('SET_RELIGIONS', rres.data)
        })
    },
    fetchOccupations({ commit }) {
        axios.get('occupations').then(ores => {
            commit('SET_OCCUPATIONS', ores.data)
        })
    },
    fetchEducationLevels({ commit }) {
        axios.get('educationlevels').then(eres => {
            commit('SET_EDUCATION_LEVELS', eres.data)
        })
    },
    fetchTribes({ commit }) {
        axios.get('tribes').then(tres => {
            commit('SET_TRIBES', tres.data)
        })
    },
    fetchSpouse({ commit }) {
        axios.get(`spouses`).then(sres => {
            commit('SET_SPOUSES', sres.data)
        })
    },


};